import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectDiscardPile } from '../ActiveGame/selectors';
import CardFace from '../Card/CardFace';
import { Slot } from '../Card/styled';
import { PlainButton } from '../Controls';
import { DISCARD } from '../ActiveGame/contextMenuTypes';
import { setContextMenu } from '../ActiveGame/actions';

const DiscardPile = ({ userId }) => {
  const dispatch = useDispatch();
  const discardPile = useSelector((state) => selectDiscardPile(state, { userId }));
  const topCard = discardPile && discardPile.get('cards').sortBy(card => card.get('order')).last();

  if (!topCard) {
    return <Slot aria-label="Empty discard pile" />;
  }

  return (
    <PlainButton onClick={() => dispatch(setContextMenu(DISCARD, userId))} aria-label="Discard pile">
      <CardFace card={topCard} count={discardPile.get('cards').size} />
    </PlainButton>
  );
};

DiscardPile.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default DiscardPile;
